<app-page-header title="Ledger Codes"></app-page-header>
<nexus-grid [data]="ledger_code_model">
    <kendo-grid-column field="code" title="Code"></kendo-grid-column>
    <kendo-grid-column field="ledger_code.name" title="Status"></kendo-grid-column>
</nexus-grid>
